module.exports = __webpack_public_path__ + "img/pin-diretor.c1913e2a.png";